import { render, staticRenderFns } from "./RecommendedColor.vue?vue&type=template&id=50e4ca1e&lang=pug&"
import script from "./RecommendedColor.vue?vue&type=script&lang=js&"
export * from "./RecommendedColor.vue?vue&type=script&lang=js&"
import style0 from "./RecommendedColor.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports